import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ResponsiveHeader from '../Header';
import {StyledMenuDiv} from '../Styled/index';
import history from '../../Utility/history';
import { privateRoutesPath } from '../../Routes';
import { styled, useTheme } from '@mui/material/styles';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleValidateCodevalue } from '../../Utility/constant';
import IconButton from '@mui/material/IconButton';
import openclose from '../../Assets/images/close_icon.png';
import '../../Assets/css/sidebar.css';
import OpenMenu from '../../Assets/images/open_icon.png';
import dashboard_select from '../../Assets/images/dashboard_select.png';
import dashboard from '../../Assets/images/dashboard.png';

import customer_select from '../../Assets/images/customer_select.png';
import customer from '../../Assets/images/customer_new.png';
import vendor from '../../Assets/images/vendor_new.png';
import vendor_select from '../../Assets/images/vendor_select.png';
import product_select from '../../Assets/images/product_select.png';
import product from '../../Assets/images/product_new.png';

import lead_select from '../../Assets/images/lead_select.png';
import lead from '../../Assets/images/lead_new.png';

import template_select from '../../Assets/images/template_select.png';
import template from '../../Assets/images/template_new.png';

import notification_select from '../../Assets/images/notification_select.png';
import notification from '../../Assets/images/campaign_new.png';
import setting_select from '../../Assets/images/settings_select.png';
import setting from '../../Assets/images/settings_new.png';

import audit_select from '../../Assets/images/audit_select.png';
import audit from '../../Assets/images/audit_new.png';

import order_select from '../../Assets/images/order_select.png';
import order from '../../Assets/images/order_new.png';
import invoice_select from '../../Assets/images/invoice_select.png';
import invoice from '../../Assets/images/invoice_new.png';
import Avatar from '@mui/material/Avatar';

const drawerWidth = 220;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    // width: '90%',
    width: `calc(100vh - ${drawerWidth}px)`,
    padding: theme.spacing(3),
    height: "100vh",
    paddingRight: "15px"
    // transition: theme.transitions.create('margin', {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.leavingScreen,
    // }),
    // // marginLeft: `-${drawerWidth}px`,
    // ...(open && {
    //   transition: theme.transitions.create('margin', {
    //     easing: theme.transitions.easing.easeOut,
    //     duration: theme.transitions.duration.enteringScreen,
    //   }),
    //   marginLeft: 0,
    // }),
  }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));


export default function PrivateLayout(props) {

    const [selectedMenu , setSelectedMenu] = React.useState('Dashboard');
    const theme = useTheme();
    const [open, setOpen] = React.useState(null);
    const dispatch = useDispatch();
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const currentUser = useSelector(state => state?.owner?.currentuser);

    const handleDrawerOpen = () => {
        setOpen(!open);
    };

    useEffect(() => {
      if(window.navigator.userAgent.match(/Chrome/i)) {
          setOpen(true);
      } else {
        setOpen(false);
      }
    },[])
    
    const handleDrawerClose = () => {
        setOpen(false);
    };


   

    const handleSelectedMenu = (menu) => {
        setSelectedMenu(menu);
        switch(menu) {
            case 'Dashboard': 
                history.push(privateRoutesPath.DASHBOARD);
                break;
            case 'Configurations': 
          history.push(privateRoutesPath.CONFIGURATION);
                break;
              }
          // history.push(privateRoutesPath.CONFIGURATION);
    }

  return (
    <Box sx={{ display: 'flex'}}>
      <CssBaseline />
      <ResponsiveHeader open={open} drawerWidth={drawerWidth} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}/>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          whiteSpace: 'nowrap',
          boxSizing: 'border-box',
          ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': {
              ...openedMixin(theme),
              overflowY : 'auto',
              top: "85px",
              left: "15px",
              borderRadius: "10px",
             height: "calc(100vh - 100px) !important",
              padding: "4px !important",
        
          
            },
          }),
          ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': {
              ...closedMixin(theme),
              overflowY : "auto",
              top: "85px",
              left: "15px",
              borderRadius: "10px",
              height: "calc(100vh - 100px) !important",
              padding: "4px !important",
        
          
            },
          }),
    
        }}
        variant="permanent"
        anchor="left"
        open={open}
      >
        <Toolbar />
        
        <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
              position: "fixed",
              top: open ? "97px" : "97px",
              left: open ? "210px" : "35px",
              transition: "all 0.3s ease",
              width: open ? "auto" : "auto",
            }}>
                  <img className={open ? "close-open" : "open-close" } src={open ? openclose : OpenMenu}  onClick={handleDrawerOpen}
              />
          </IconButton>
        
        <Box sx={{  height: '100vh'}}>
          <List>
              <StyledMenuDiv>
                <ListItem key="Dashboard" sx={{ display: 'block' }} disablePadding onClick={() => handleSelectedMenu('Dashboard')}>
                <ListItemButton
                  sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'initial',
                  px: 2.5,
                }}
                // selected = {selectedMenu == 'Dashboard' }
                selected = {props.location.pathname.split("/").includes('dashboard')}
                >
                    <ListItemIcon
                     sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'initial',
                      }}
                    // sx={{minWidth: 0}}
                    >
                    {props.location.pathname.split("/").includes('dashboard')  ? <img src={dashboard_select} /> : <img src={dashboard} /> }
                    </ListItemIcon>
                  <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"DASHBOARD_SIDEBAR_MENU")} />
                </ListItemButton>
              </ListItem>

                <ListItem key='Configurations' disablePadding onClick={() => handleSelectedMenu('Configurations')}>
                    <ListItemButton sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    //  selected = {selectedMenu == 'Configurations' }
                     selected = {props.location.pathname.split("/").includes('configuration')}
                     
                     >
                        <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                          {props.location.pathname.split("/").includes('configuration') ? <img src={setting_select} /> : <img src={setting} />  }
                        </ListItemIcon>
                    <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"CONFIGURATION_SIDEBAR_MENU")} />
                    </ListItemButton>
                </ListItem>
              </StyledMenuDiv>
           </List>
          <Divider />
        </Box>
      </Drawer>
      <Main open={open}>
        {/* <Box open={open} component="main" sx={{  flexGrow: 1, p: 3 }}> */}
          <Toolbar />
          {props.children}
        {/* </Box> */}
      </Main>
    </Box>
  );
}